<template>
    <div class="popup-cart__region-block js-popup-cart-item js-cart-item" :class="{'remove': removeProduct === product.id}">
        <div class="popup-cart__item-delete"
            @click="cartModalBtn(product.id, 0, 0, 1, 'delete', product.data_info)"
            @touchend="cartModalBtn(product.id, 0, 0, 1, 'delete', product.data_info)">
            <img class="nohov" src="/img/popup-cart/delete.svg?v=2" alt="delete">
            <img class="hov" src="/img/popup-cart/delete-active.svg?v=2" alt="delete">
        </div>
        <div class="popup-cart__region-info-container" v-if="product?.region">
            <div class="popup-cart__region-status-img">
                <img v-if="product.region?.is_restricted" src="/img/tmp/region-load.svg?=v1" alt="region">
                <img v-else-if="product.region?.has_country || product.region.region_name_tech === 'GLOBAL'" src="/img/tmp/region-accept.svg?=v1" alt="region">
                <img v-else src="/img/tmp/region-decline.svg?=v1" alt="region">
            </div>
            <div class="popup-cart__region-info-wrap" ref="regionInfoWrap">
                <span ref="regionInfoStatus" class="popup-cart__region-info-status">
                    <div class="region-info__region-info" :class="product.region.has_country || product.region.region_name_tech === 'GLOBAL' ? 'active' : 'no-active'">
                        <span class="region-info__country-status region-info__text  region-info__text--lg region-info__text--white region-info__text--uppercase">
                            {{ product.region.region_name ? product.region.region_name : product.region.region_name_tech }}
                        </span>
                    </div>
                </span>
                <span ref="regionInfoText" class="popup-cart__region-info-text" :class="{animate: addAnimateToRegion}">
                    <span class="popup-cart__region-info-animate">
                        <span v-if="product.region.is_restricted" class="region-info__text"
                            v-html="$t('Activation in {country} may be difficult', { 
                                country: `<span class='region-info__text--white region-info__text--bold'>${product.region.country_name}</span>`
                            })">
                        </span>
                        <template v-else-if="product.region.region_name_tech === 'GLOBAL'">
                            <span v-if="mobile" class="region-info__text mobile">{{ $t('Can be activated') }}</span>
                            <span v-else class="region-info__text desctop"> - {{ $t('Can be activated from any country') }}</span>
                        </template>
                        <span v-else-if="product.region.region_name_tech === 'LATAM'" 
                                class="region-info-modal__status-coutnry region-info-modal__status-coutnry--flex-wrap region-info-modal__text region-info-modal__text--lg region-info-modal__text--light">
                            {{ $t("Can't be activated") }} 
                            <span class="region-info-modal__text region-info-modal__text--lg region-info-modal__text--regular region-info-modal__text--white">
                                {{ product.region.region_name }}
                            </span>
                        </span>
                        <span v-else-if="product.region.has_country" class="region-info__text">
                            - {{ $t('Can be activate in') }} 
                            <span class="region-info__text--white region-info__text--bold">{{ product.region.country_name }}</span>
                        </span>
                        <span v-else class="region-info__text">
                            - {{ $t("Can't be activated") }} 
                            <span class="region-info__text--white region-info__text--bold">{{ product.region.region_name }}</span>
                        </span>
                        <span v-if="addAnimateToRegion" class="region-info__text added">{{ animateText }}</span>
                        <span v-if="addAnimateToRegion" class="region-info__text added">{{ animateText }}</span>
                    </span>
                </span>
            </div>

            <template v-if="(!!product?.label_data?.category_id || product?.label_data?.class || product.is_account) && !mobile">
                <div v-if="product.label_data.class === 'pre-order'" class="product__label-cart hide-mobile">
                    <div class="product__label-cart-item g-6 border-right">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.77461 5.49882C9.5471 4.98677 9.21638 4.52719 8.80313 4.14881L8.46211 3.83592C8.45053 3.82559 8.43659 3.81826 8.42152 3.81457C8.40645 3.81088 8.3907 3.81095 8.37566 3.81477C8.36062 3.81858 8.34674 3.82604 8.33525 3.83647C8.32377 3.8469 8.31501 3.85999 8.30977 3.8746L8.15742 4.31171C8.0625 4.58592 7.88789 4.866 7.64062 5.14139C7.62422 5.15897 7.60547 5.16366 7.59258 5.16483C7.57969 5.166 7.55977 5.16366 7.54219 5.14725C7.52578 5.13319 7.51758 5.1121 7.51875 5.091C7.56211 4.38553 7.35117 3.58983 6.88945 2.72381C6.50742 2.00428 5.97656 1.44295 5.31328 1.05155L4.8293 0.766783C4.76602 0.729283 4.68516 0.778502 4.68867 0.85233L4.71445 1.41483C4.73203 1.7992 4.6875 2.13905 4.58203 2.42147C4.45312 2.76717 4.26797 3.08827 4.03125 3.37655C3.86651 3.5769 3.6798 3.75811 3.47461 3.91678C2.98044 4.29666 2.57861 4.78342 2.29922 5.34061C2.02052 5.90266 1.87534 6.52146 1.875 7.14881C1.875 7.70194 1.98398 8.23749 2.19961 8.74256C2.40781 9.22885 2.70827 9.67019 3.08438 10.0422C3.46406 10.4172 3.90469 10.7125 4.3957 10.9176C4.9043 11.1308 5.44336 11.2387 6 11.2387C6.55664 11.2387 7.0957 11.1308 7.6043 10.9187C8.0941 10.7149 8.53951 10.4175 8.91562 10.0433C9.29531 9.66835 9.59297 9.23006 9.80039 8.74374C10.0157 8.24004 10.1261 7.69777 10.125 7.14999C10.125 6.57811 10.0078 6.02264 9.77461 5.49882Z" fill="#FCE9A7"/>
                        </svg>
                        <span class="text-bold">{{product.label_data.text}}</span>
                    </div>
                    <div class="product__label-cart-item" v-if="product.label_data?.release_date">
                        <span class="text-light">{{product.label_data.release_date}}</span>
                    </div>
                </div>
                <div v-else-if="product.label_data.class == 'adult'" class="product__label-category-cart hide-mobile account">
                    <img class="product__label-category-cart-image" src="/img/pages/product/icons/label/adult.svg" alt="adult icon">
                    <span class="product__label-category-cart-name">{{ $t('Content') }}</span>
                </div>
                <div v-else-if="product.is_account" class="product__label-category-cart hide-mobile account">
                    <span class="product__label-category-cart-image account"></span>
                    <span class="product__label-category-cart-name">{{ $t('Account') }}</span>
                </div>
                <div v-else class="product__label-category-cart hide-mobile">
                    <span class="product__label-category-cart-image" :class="product.label_data.class"></span>
                    <span class="product__label-category-cart-name">{{product.label_data.text}}</span>
                </div>
            </template>
        </div>
        <div class="popup-cart__item-container item row count-wrap" :class="product?.region ? '' : 'not-region'" :data-item="product.id":data-info='product.info'>
            <template v-if="(!!product.label_data.category_id || product.is_account) && mobile">
                <div v-if="product.label_data.class === 'pre-order'" class="product__label-cart hide-desctop">
                    <div class="product__label-cart-item g-6 border-right">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.77461 5.49882C9.5471 4.98677 9.21638 4.52719 8.80313 4.14881L8.46211 3.83592C8.45053 3.82559 8.43659 3.81826 8.42152 3.81457C8.40645 3.81088 8.3907 3.81095 8.37566 3.81477C8.36062 3.81858 8.34674 3.82604 8.33525 3.83647C8.32377 3.8469 8.31501 3.85999 8.30977 3.8746L8.15742 4.31171C8.0625 4.58592 7.88789 4.866 7.64062 5.14139C7.62422 5.15897 7.60547 5.16366 7.59258 5.16483C7.57969 5.166 7.55977 5.16366 7.54219 5.14725C7.52578 5.13319 7.51758 5.1121 7.51875 5.091C7.56211 4.38553 7.35117 3.58983 6.88945 2.72381C6.50742 2.00428 5.97656 1.44295 5.31328 1.05155L4.8293 0.766783C4.76602 0.729283 4.68516 0.778502 4.68867 0.85233L4.71445 1.41483C4.73203 1.7992 4.6875 2.13905 4.58203 2.42147C4.45312 2.76717 4.26797 3.08827 4.03125 3.37655C3.86651 3.5769 3.6798 3.75811 3.47461 3.91678C2.98044 4.29666 2.57861 4.78342 2.29922 5.34061C2.02052 5.90266 1.87534 6.52146 1.875 7.14881C1.875 7.70194 1.98398 8.23749 2.19961 8.74256C2.40781 9.22885 2.70827 9.67019 3.08438 10.0422C3.46406 10.4172 3.90469 10.7125 4.3957 10.9176C4.9043 11.1308 5.44336 11.2387 6 11.2387C6.55664 11.2387 7.0957 11.1308 7.6043 10.9187C8.0941 10.7149 8.53951 10.4175 8.91562 10.0433C9.29531 9.66835 9.59297 9.23006 9.80039 8.74374C10.0157 8.24004 10.1261 7.69777 10.125 7.14999C10.125 6.57811 10.0078 6.02264 9.77461 5.49882Z" fill="#FCE9A7"/>
                        </svg>
                        <span class="text-bold">{{product.label_data.text}}</span>
                    </div>
                    <div class="product__label-cart-item" v-if="product.label_data?.release_date">
                        <span class="text-light">{{product.label_data.release_date}}</span>
                    </div>
                </div>
                <div v-else-if="product.is_account" class="product__label-category-cart hide-desctop account">
                    <span class="product__label-category-cart-image account"></span>
                    <span class="product__label-category-cart-name">{{ $t('Account') }}</span>
                </div>
                <div v-else class="product__label-category-cart hide-desctop">
                    <span class="product__label-category-cart-image" :class="product.label_data.class"></span>
                    <span class="product__label-category-cart-name">{{product.label_data.text}}</span>
                </div>
            </template>
            <div class="popup-cart__item-img">
                <img :src="product.img.src"
                    :alt="product.img.alt"
                    :title="product.img.title">
            </div>

            <div class="popup-cart__item-controls">
                <div class="popup-cart__item-title-wrap">
                    <div class="popup-cart__item-title-fade">
                        <h6 class="popup-cart__item-title">{{product.title}}</h6>
                    </div>
                </div>
                <div class="popup-cart__subitem">
                    <a :href="`/${language}/profile/${product.user.username}`" class="seller-profile">
                        <img :src="product.user.avatar.url"
                             :alt="product.user.avatar.alt"
                             :title="product.user.avatar.title"
                             class="img-circle img-responsive">
                        {{product.user.username}}
                    </a>
                    <div class="divider"></div>
                    
                    <div class="cart-page__controls-info-category">
                        <span class="category-title">{{product.offer_type_name}}</span>
                    </div>
                </div>
                <div class="popup-cart__item-controls-row" :class="{'currency-controls': product.is_game_currency}">
                    <div v-if="product.is_game_currency" class="cart-calc currency-calculator js-cart-range-slider-container">
                        <div class='cart-calc__wrap currency'>
                            <div class="cart-calc__range-block">
                                <div class="cart-calc__btn cart-calc__btn--minus js-minus down" @click="cartModalBtn(product.id, product.quantity, product.min_order_quantity, product.stock, 'down')">
                                    <span><img src="/img/cart/minus.svg" alt="minus"></span>
                                </div>
                                <div class="cart-calc__range-wrap">
                                    <input  type="range"
                                            :min="product.min_order_quantity"
                                            :max="product.stock"
                                            :step="1"
                                            v-model="product.quantity"
                                            class="cart-calc__range-input range-slider"
                                            @input="handleInput"
                                            @change="handleChange">
                                    <div class="cart-calc__range-bg js-cart-range-slider-range"
                                            :style="{ width: calculatedWidth }"></div>
                                </div>
                                <div class="cart-calc__btn cart-calc__btn--plus js-plus up" @click="cartModalBtn(product.id, product.quantity, product.min_order_quantity, product.stock, 'up')">
                                    <span><img src="/img/cart/plus.svg" alt="plus"></span>
                                </div>
                            </div>
                            <div class="cart-calc__block-amount">
                                <span class="amount count">{{formatCurrency(quantityValue)}}</span>
                                <span class="cart-calc__block-amount-text">
                                    {{product.game_currency_units}}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div v-else class="popup-cart__calculator-wrap">

                        <div class="popup-cart__calculator count-row relative"
                            :data-item="product.id">
                            <template v-if="!product.is_boosting">
                                <a class="popup-cart__calculator-btn popup-cart__calculator-btn--minus down" @click="cartModalBtn(product.id, product.quantity, product.min_order_quantity, product.stock, 'down')">
                                    <span>
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M13.2174 7.44928H2.78261C2.71884 7.44928 2.66667 7.50145 2.66667 7.56522V8.43479C2.66667 8.49855 2.71884 8.55073 2.78261 8.55073H13.2174C13.2812 8.55073 13.3333 8.49855 13.3333 8.43479V7.56522C13.3333 7.50145 13.2812 7.44928 13.2174 7.44928Z" fill="#F6F6F6"/>
                                        </svg>
                                    </span>
                                </a>
                                <span class="popup-cart__calculator-val count">{{product.quantity_formatted}}</span>
                                <a class="popup-cart__calculator-btn popup-cart__calculator-btn--plus up" @click="cartModalBtn(product.id, product.quantity, product.min_order_quantity, product.stock, 'up')">
                                    <span>
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M13.2174 7.44928H2.78261C2.71885 7.44928 2.66667 7.50145 2.66667 7.56522V8.43479C2.66667 8.49855 2.71885 8.55073 2.78261 8.55073H13.2174C13.2812 8.55073 13.3333 8.49855 13.3333 8.43479V7.56522C13.3333 7.50145 13.2812 7.44928 13.2174 7.44928Z" fill="#F6F6F6"/>
                                            <path d="M7.44922 2.78265L7.44922 13.2174C7.44922 13.2812 7.50139 13.3334 7.56516 13.3334H8.43473C8.49849 13.3334 8.55067 13.2812 8.55067 13.2174V2.78265C8.55067 2.71888 8.49849 2.66671 8.43473 2.66671H7.56516C7.50139 2.66671 7.44922 2.71888 7.44922 2.78265Z" fill="#F6F6F6"/>
                                        </svg>
                                    </span>
                                </a>
                            </template>
                        </div>
                    </div>
                    <p v-if="product.is_game_currency" class="popup-cart__item-price currency" :class="{discount: discountCostValue}">
                        <span class="price-old">{{product.symbol}}&nbsp;{{formatCurrency(costValue)}}</span>
                        <span class="price-new" v-if="discountCostValue">{{product.symbol}}&nbsp;{{formatCurrency(discountCostValue)}}</span>
                    </p>
                    <p v-else class="popup-cart__item-price" :class="{discount: product?.discount_cost && !isUserSeller}">
                        <span class="price-old">{{product.cost}}</span>
                        <span class="price-new" v-if="product?.discount_cost && !isUserSeller">{{product.discount_cost}}</span>
                    </p>
                </div>
            </div>
        </div>
        <div class="popup-cart__discount-block" v-if="product?.discount">
            <p class="popup-cart__discount-text" v-html="discountText"></p>
        </div>
        <div class="popup-cart__labels-container">
            <div v-if="product.label_data.is_preorder" class="popup-cart__messages-container alert-yellow">
                <div class="popup-cart__alert-title" @click="toggleInfo">
                    <img src="/img/cart/alert-yellow.svg" alt="alert" class="label-icon">
                    <span v-if="product.is_account" v-html="$t('This game is {tag}', { tag: `<b>${$t('not a digital key')}</b>` })"></span>
                    <span v-else v-html="$t('This game is in {tag}', { tag: `<b>${$t('pre-order status')}</b>` })"></span>
                    <img src="/img/ui-kit/chevron.svg" alt="chevron" class="arrow" :class="{active: isActiveToggleInfo }">
                </div>
                <SlideUpDown :isActive="isActiveToggleInfo">
                    <span v-if="product.is_account" class="popup-cart__alert-message" v-html="
                        $t('This game is {tag}', { tag: `<b>${$t('not a digital key')}</b>` }) + ' ' +
                        $t('You will receive access to an account with a digital product in {tag} (available after release).', { tag: `<b>${$t('pre-order status')}</b>` })
                    "></span>
                    <span v-else class="popup-cart__alert-message"
                        v-html="$t('This game is in {tag} and will be available for Download/Installation on the day of release.', { tag: `<b>${$t('pre-order status')}</b>` })"></span>
                </SlideUpDown>
            </div>
            <div v-else-if="product.label_data.class == 'adult'" class="popup-cart__messages-container alert-yellow">
                <div class="popup-cart__alert-title" @click="toggleInfo">
                    <img src="/img/cart/alert-yellow.svg" alt="alert" class="label-icon">
                    <span v-html="$t('This product is {tag}', { tag: `<b>18+</b>` })"></span>
                    <img src="/img/ui-kit/chevron.svg" alt="chevron" class="arrow" :class="{active: isActiveToggleInfo }">
                </div>
                <SlideUpDown :isActive="isActiveToggleInfo">
                    <span class="popup-cart__alert-message" v-html="
                        $t('To complete the purchase of this product, you must confirm that you are {age} or older.', {
                            age: '<b>' + this.$t('18 years') + '</b>',
                        })
                    "></span>
                </SlideUpDown>
            </div>
            <div v-else-if="product.label_data.is_dlc" class="popup-cart__messages-container alert-blue" :class="product.is_account ? 'alert-yellow': 'alert-blue'">
                <div class="popup-cart__alert-title" @click="toggleInfo">
                    <img v-if="product.is_account" src="/img/cart/alert-yellow.svg" alt="alert" class="label-icon">
                    <img v-else src="/img/cart/alert-blue.svg" alt="alert" class="label-icon">
                    <span v-html="$t('This product is {tag}', { tag: `<b>DLC</b>` })"></span>
                    <img src="/img/ui-kit/chevron.svg" alt="chevron" class="arrow" :class="{active: isActiveToggleInfo }">
                </div>
                <SlideUpDown :isActive="isActiveToggleInfo">
                    <span v-if="product.is_account" class="popup-cart__alert-message" v-html="
                        $t('Please note that this product is {tag}.', { tag: `<b>${$t('not a digital key')}</b>` }) + ' ' +
                        $t('You will receive access to an account with a digital product.')
                    "></span>
                    <span v-else class="popup-cart__alert-message">
                        {{ $t('This product is an add-on to the main game, you can use it if you have the game itself.') }}
                    </span>
                </SlideUpDown>
            </div>
            <div v-else-if="product.is_account" class="popup-cart__messages-container alert-yellow">
                <div class="popup-cart__alert-title" @click="toggleInfo">
                    <img src="/img/cart/alert-yellow.svg" alt="alert" class="label-icon">
                    <span v-html="$t('This product is {tag}', { tag: `<b>${$t('not a digital key')}</b>` })"></span>
                    <img src="/img/ui-kit/chevron.svg" alt="chevron" class="arrow" :class="{active: isActiveToggleInfo }">
                </div>
                <SlideUpDown :isActive="isActiveToggleInfo">
                    <span class="popup-cart__alert-message" v-html="
                        $t('Please note that this product is {tag}.', { tag: `<b>${$t('not a digital key')}</b>` }) + ' ' +
                        $t('You will receive access to an account with a digital product.')
                    "></span>
                </SlideUpDown>
            </div>
            <div v-else-if="product.is_online" class="popup-cart__messages-container mobile">
                <div class="popup-cart__alert-title"  @click="toggleInfo">
                    <img src="/img/cart/mobile.svg" alt="mobile" class="label-icon">
                    <span>{{ $t('Delivery information') }}</span>
                    <img src="/img/ui-kit/chevron.svg" alt="chevron" class="arrow" :class="{active: isActiveToggleInfo }">
                </div>
                <SlideUpDown :isActive="isActiveToggleInfo">
                    <span v-if="product.is_boosting" class="popup-cart__alert-message" v-html="
                        $t('After confirming your order, the boosting service will be provided {tag}.', { tag: `<span>${$t('within') + ' ' + product.delivery_title}</span>` }) + '<br>' +
                        $t(`You can track your order's progress on the {tag} or contact the seller.`, { tag: `<a href='/order'>${$t('Order Page')}</a>` })
                    "></span>
                    <span v-else class="popup-cart__alert-message" v-html="
                        $t('After confirming your order, your product will be delivered {tag}.', { tag: `<span>${$t('within') + ' ' + product.delivery_title}</span>` }) + '<br>' +
                        $t(`You can track your order's progress on the {tag} or contact the seller.`, { tag: `<a href='/order'>${$t('Order Page')}</a>` })
                    "></span>
                </SlideUpDown>
            </div>
            <div v-else-if="!product.is_online" class="popup-cart__messages-container mobile">
                <div class="popup-cart__alert-title" @click="toggleInfo">
                    <img src="/img/cart/mobile.svg" alt="mobile" class="label-icon">
                    <span>{{ $t('Delivery information') }}</span>
                    <img src="/img/ui-kit/chevron.svg" alt="chevron" class="arrow" :class="{active: isActiveToggleInfo }">
                </div>
                <SlideUpDown :isActive="isActiveToggleInfo">
                    <span v-if="product.live_stock" class="popup-cart__alert-message" v-html="
                        $t('After confirming your order, your product will be delivered {tag}.', { tag: `<span>${$t('instantly')}</span>` }) + '<br>' +
                        $t(`You can track your order's progress on the {tag} or contact the seller.`, { tag: `<a href='/order'>${$t('Order Page')}</a>` })
                    "></span>
                    <span v-else class="popup-cart__alert-message" v-html="
                        $t('After confirming your order, your product will be delivered {tag}.', { tag: `<span>${$t('within') + ' ' + product.delivery_title}</span>` }) + '<br>' +
                        $t(`You can track your order's progress on the {tag} or contact the seller.`, { tag: `<a href='/order'>${$t('Order Page')}</a>` })
                    "></span>
                </SlideUpDown>
            </div>            
        </div>
    </div>
  </template>
  
  <script>
import SlideUpDown from '/webpack-assets/vue/components/SlideUpDown.vue';
import { ref, onMounted, nextTick } from 'vue';

  export default {
    name: 'ModalAddToCartItem',
    components: {
        SlideUpDown
    },
    props: {
        mobile: {
            type: Boolean,
            default: false,
        },
        isUserSeller: {
            type: Boolean,
            default: false,
        },
        language: {
            type: String,
            default: 'en',
        },
        cartCountProps: {
            type: Number,
            default: 0
        },
        cartCostProp: {
            type: String,
            default: ''
        },
        product: {
            type: Object,
            default: () => {},
        },
    },
    data() {
      return {
        removeProduct: null,
        cartCount: null,
        isActiveToggleInfo: true,
        costValue: this.product.cost_value,
        discountCostValue: this.product?.discount_cost_value,
        quantityValue: this.product.quantity,
        addAnimateToRegion: false,
        animateText: null,
        updateTimeout: null,
        pendingUpdates: {}
      };
    },
    computed: {
        discountText() {
            const { discount } = this.product;

            if (!discount) return '';

            const selfDiscountText = discount.selfDiscount
                ? this.$t('You have {tag}.', {
                    tag: `<span>${this.$t('discount ({discount}%)', {
                    discount: discount.selfDiscount,
                    })}</span>`,
                }) + ' '
                : '';

            const nextDiscountText =
                discount.diffCount && discount.nextDiscount
                ? this.$t('Get {discount} by adding {product} from this seller', {
                    discount: `<span>${this.$t('{disc} % off', {
                        disc: discount.nextDiscount,
                    })}</span>`,
                    product: `<span>${this.$t('{product} more product', {
                        product: discount.diffCount,
                    })}</span>`,
                    })
                : '';

            return selfDiscountText + nextDiscountText;
        },
        calculatedWidth() {
            if (
                !this.product ||
                !this.product.min_order_quantity ||
                !this.product.stock ||
                !this.product.unit_price
            ) {
                return '0%';
            }

            const min = this.product.min_order_quantity;
            const max = this.product.stock;

            if (min < 0 || max < 0 || max <= min) {
                return '0%';
            }

            const range = (this.product.quantity - min) / ((max - min) / 100);

            if (isNaN(range) || !isFinite(range)) {
                return '0%';
            }

            return range < 40
                ? `calc(${Math.max(range, 0)}% + 5px)`
                : `${Math.max(range, 0)}%`;
        },
    },
    mounted() {
        if(this.mobile) {
            this.isActiveToggleInfo = false
            nextTick(() => {
                this.getRegionInfoWidths();
            });
        }
    },
    methods: {
        toggleInfo() {
            if (this.mobile) {
                this.isActiveToggleInfo = !this.isActiveToggleInfo;
            }
        },
        getRegionInfoWidths() {
            const statusEl = this.$refs.regionInfoStatus;
            const textEl = this.$refs.regionInfoText;
            const wrapEl = this.$refs.regionInfoWrap;

            if (!statusEl || !textEl || !wrapEl) {
                return;
            }
            const statusWidth = statusEl.offsetWidth || 0;
            const textWidth = textEl.offsetWidth || 0;
            const wrapWidth = wrapEl.offsetWidth || 0;

            if (wrapWidth < statusWidth + textWidth) {
                this.addAnimateToRegion = true;
                this.animateText = textEl.textContent || '';
            } else {
                this.addAnimateToRegion = false;
                this.animateText = null;
            }
        },
        cartModalBtn(id, count, minCount = 1, maxCount, btn, dataInfo = {}) {
            count = parseFloat(count) || 0;

            let newCount = count;
            switch (btn) {
                case 'down':
                    newCount = Math.max(count - 1, minCount);
                    break;
                case 'up':
                    newCount = Math.min(count + 1, maxCount);
                    break;
                case 'delete':
                    this.removeProduct = id;
                    newCount = 0;
                    window.tagTracking("removeFromCart", dataInfo)
                    break;
                default:
                    console.warn(btn);
                    return;
            }

            this.pendingUpdates[id] = newCount;
            this.updateValues();

            clearTimeout(this.updateTimeout);
            this.updateTimeout = setTimeout(() => {
                Object.entries(this.pendingUpdates).forEach(([productId, finalCount]) => {
                    window.updateMiniCarts(finalCount, productId);
                });
                this.pendingUpdates = {};
            }, 300);
        },
        handleInput() {
            this.updateValues();
        },
        handleChange() {
            window.updateMiniCarts(this.product.quantity, this.product.id);
            this.updateValues();
        },
        updateValues() {
            const pricePerUnit = this.product.unit_price || 0;
            const percentItem = this.product.percent || 0;
            const amount = this.product.quantity * pricePerUnit;
            
            this.quantityValue = this.product.quantity;
            this.costValue = amount < 0.01 ? 0.01 : amount;
            if(percentItem !== 0) {
                this.discountCostValue = this.costValue - (this.costValue * percentItem / 100);
            }
        },
        formatCurrency(amount) {
            return Number(amount)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                .replace(",", ".");
        }
    },
    watch: {
        product: {
            handler(newProduct) {
                if (newProduct) {
                    this.costValue = newProduct.cost_value || 0;
                    this.discountCostValue = newProduct.discount_cost_value || 0;
                    this.quantityValue = newProduct.quantity || 0;
                }
            },
            deep: true,
        },
    }
  };
  </script>
  
  <style scoped lang="scss">

  </style>
  